import { Helmet } from 'react-helmet';

const HVHelmet = ({ children }) => (
    <Helmet defaultTitle="Healthvana" titleTemplate="%s | Healthvana">
        {children}
    </Helmet>
);

export default HVHelmet;
